import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  Inject,
  ViewContainerRef
} from "@angular/core";
import { MktContentStorageService, MktTaggingTransformationService } from "src/app/core/services";
import { isDesktop } from "../../utility/browser-util";
import { ActivatedRoute } from '@angular/router';
import { MktDynamicModalService } from "src/app/common/services/mkt-dynamic-modal.service";
import { CitiShopPropsService } from "../../utility/citi-shop-props.service";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-citi-shop-safari-instructions",
  templateUrl: "./citi-shop-safari-instructions.component.html",
  styleUrls: ["./citi-shop-safari-instructions.component.scss"],
  providers: [MktDynamicModalService],
  standalone: false
})
export class CitiShopSafariInstructionsComponent implements AfterViewInit {
  backgroundImage: any;
  content: any;
  iOSSafariContent: any;
  @Input() contentMobile: any = '{}';
  displayChromeMsg = false;
  displaySafariContent = false;
  routeUrl: any;
  imgContent: any;
  citishopContent!: any;
  speedBumpDialogContent!: any;
  playbuttonStatus = false;
  playButtonImg = '';
  instructionsImg = '';
  displayEnrollmentBtn: boolean = false;

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private mktDynamicModalService: MktDynamicModalService,
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    public csp: CitiShopPropsService,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.citishopContent = this._mktContentStorageService.get('Digital_Wallet', 'copy', 'Citi-Shop');
    if (this.citishopContent && this.citishopContent.TEXT) {
      this.speedBumpDialogContent = this.citishopContent['speedBumpDialog'];
    }

    try {
      this.content = this.contentMobile;
    } catch (e) {
      console.error('Invalid Content: ', e.message);
    }
    this.routeUrl = this.route.snapshot.params;

    if (!this.csp.isBrowser() || (this.routeUrl.pageType?.toLowerCase() === 'iossafari'
      && this.csp.browserName()?.toLowerCase() === 'safari' && !isDesktop())) {
      this.displaySafariContent = true;
      this.iOSSafariContent = { ...this.content?.iOSSafariMobile, citishopLogoPath: this.content?.citishopLogoPath };
    }
    else if (
      this.csp.browserName().toLowerCase() === "chrome" ||
      this.csp.browserName() === "Unknown"
    ) {
      this.displayChromeMsg = true;
    } else {
      this.displayChromeMsg = false;
    }
    
    if( this.content.showCopyEnrollmentLinkBtn === "true") {
      this.displayEnrollmentBtn = true;
    }
  }

  ngAfterViewInit(): void {
    this.mktDynamicModalService.addModalListenerToElements(this.elementRef, '.speedbump-external-link', this.viewContainerRef, 'CitiShopSpeedbumpDialogComponent', { dialogContent: this.speedBumpDialogContent });
    this.playStop();
    this.highlightAllSteps();
  }

  playInteraction(): void {
    if (!this.playbuttonStatus) {
      this._mktTaggingTransformationService.tagMktCompareCards('citishop_prelogin_instructions_video_interaction', { page_inter: 'Play' });
    }
    this.playStop();
  }

  ctaInteraction(event: any): void {
    const name = event.target.attributes.title.nodeValue;
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_prelogin_instructions_ctaclicked', { link_name: name });
  }

  playStop(): void {
    if (this.playbuttonStatus) {
      this.playButtonImg = this.iOSSafariContent?.playIcon?.imgSrc;
      this.instructionsImg = this.iOSSafariContent?.mobile[0]?.imgSrc;
      this.resetSteps();
      this._document.getElementById('li-cirlce-1').className = "active-circle";
      this.playbuttonStatus = !this.playbuttonStatus;
    } else {
      this.playButtonImg = this.iOSSafariContent?.stopIcon?.imgSrc;
      this.instructionsImg = this.iOSSafariContent?.instructionGif?.imgSrc;
      this.highlightAllSteps();
    }
  }

  highlightSteps(e: any, i: number): void {
    this.resetSteps();
    this._document.getElementById('li-cirlce-' + i).className = "active-circle";
    this.instructionsImg = this.iOSSafariContent?.mobile[i - 1]?.imgSrc;
    this.playButtonImg = this.iOSSafariContent?.playIcon?.imgSrc;
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_prelogin_instructions_video_interaction', { page_inter: 'Part ' + i });
    this.playbuttonStatus = false;
  }
  resetSteps(): void {
    for (let i = 1; i <= this.iOSSafariContent?.listSteps?.length; i++) {
      this._document.getElementById('li-cirlce-' + i).className = "circle";
    }
  }
  highlightAllSteps(): void {
    for (let i = 1; i <= this.iOSSafariContent?.listSteps?.length; i++) {
      this._document.getElementById('li-cirlce-' + i).className = "active-circle";
    }
    this.playbuttonStatus = true;
  }
  copyEnrollmentLink() {
    navigator.clipboard.writeText(this.content.enrollmentLink);
  }
}
